export const environment = {
  production: false,
  SENTRY_DSN: 'https://0abc4f47dcba887d7e188e15435af429@o4506633830989824.ingest.us.sentry.io/4507103771820032',
  EC2URL: 'https://ptwfservices.wordflight.com/',
  AssetServerURL: 'https://ptstudent.wordflight.com',
  VideoAssetServerURL: 'https://ptstudent.wordflight.com',
  CLEVER_REDIRECT_URI: 'https://ptwfservices.wordflight.com/clever/login',
  CLEVER_CLIENT_ID: '61055c415b22e16bc101',
  CLASSLINK_REDIRECT_URI: 'https://ptwfservices.wordflight.com/classlink/login',              
  CLASSLINK_CLIENT_ID: 'c1632169550751eae0c3c3c39e2ee2dec72ab90b24df',
  versionNumber: '7.005',
  'appStoreLink': 'https://apps.apple.com/us/app/wordflight-student/id1584915043',
  // Specifies how many seconds a student should finish a trial within.
  // If a task takes  more than this time on aggregate, student will
  // be notified and poor usage might be reported.
  trialSecondsLimit: 60,
  RTW_MAX_RECORD_SEC: 10,
  RTS_MAX_RECORD_SEC: 30,
};
